export default "__VITE_ASSET__D_rx1Wdb__"